const Disabled = () => {
    return (
        <div className="InstrumentDisabled">
            <p className="InstrumentDisabled__Icon"><i className="bi bi-slash-circle"></i></p>
            <p className="InstrumentDisabled__Title">Lo sentimos</p>
            <p className="InstrumentDisabled__Text">No tienes permitido el acceso a este instrumento.</p>
        </div>
    )
}

export { Disabled };